import { render, staticRenderFns } from "./CreateAllRightRequest.vue?vue&type=template&id=d021b5f8&scoped=true"
import script from "./CreateAllRightRequest.vue?vue&type=script&lang=js"
export * from "./CreateAllRightRequest.vue?vue&type=script&lang=js"
import style0 from "./CreateAllRightRequest.vue?vue&type=style&index=0&id=d021b5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d021b5f8",
  null
  
)

export default component.exports